var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaserScanIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 59,
    viewBox: "0 0 78 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78037 8.01869C4.78037 7.06542 5.56542 6.28037 6.51869 6.28037H9.93925C10.2477 6.28037 10.5 6.02804 10.5 5.71963V3.56075C10.5 3.25234 10.2477 3 9.93925 3H6.51869C3.74299 3 1.5 5.24299 1.5 8.01869V11.4393C1.5 11.7477 1.75234 12 2.06075 12H4.21963C4.52804 12 4.78037 11.7477 4.78037 11.4393V8.01869Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78037 47.9813C4.78037 48.9346 5.56542 49.7196 6.51869 49.7196H9.93925C10.2477 49.7196 10.5 49.972 10.5 50.2804V52.4393C10.5 52.7477 10.2477 53 9.93925 53H6.51869C3.74299 53 1.5 50.757 1.5 47.9813V44.5607C1.5 44.2523 1.75234 44 2.06075 44H4.21963C4.52804 44 4.78037 44.2523 4.78037 44.5607V47.9813Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2196 8.01869C73.2196 7.06542 72.4346 6.28037 71.4813 6.28037H68.0607C67.7523 6.28037 67.5 6.02804 67.5 5.71963V3.56075C67.5 3.25234 67.7523 3 68.0607 3H71.4813C74.257 3 76.5 5.24299 76.5 8.01869V11.4393C76.5 11.7477 76.2477 12 75.9393 12H73.7804C73.472 12 73.2196 11.7477 73.2196 11.4393V8.01869Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2196 47.9813C73.2196 48.9346 72.4346 49.7196 71.4813 49.7196H68.0607C67.7523 49.7196 67.5 49.972 67.5 50.2804V52.4393C67.5 52.7477 67.7523 53 68.0607 53H71.4813C74.257 53 76.5 50.757 76.5 47.9813V44.5607C76.5 44.2523 76.2477 44 75.9393 44H73.7804C73.472 44 73.2196 44.2523 73.2196 44.5607V47.9813Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 12,
    width: 2,
    height: 15,
    rx: 1,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 30,
    width: 2,
    height: 14,
    rx: 1,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 12,
    width: 3,
    height: 15,
    rx: 1,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 30,
    width: 3,
    height: 14,
    rx: 1,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 12,
    width: 2,
    height: 15,
    rx: 1,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 30,
    width: 2,
    height: 14,
    rx: 1,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 12,
    width: 4,
    height: 15,
    rx: 1,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 30,
    width: 4,
    height: 14,
    rx: 1,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 12,
    width: 3,
    height: 15,
    rx: 1,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 30,
    width: 3,
    height: 14,
    rx: 1,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 12,
    width: 2,
    height: 15,
    rx: 1,
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 30,
    width: 2,
    height: 14,
    rx: 1,
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 12,
    width: 4,
    height: 15,
    rx: 1,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 30,
    width: 4,
    height: 14,
    rx: 1,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 12,
    width: 3,
    height: 15,
    rx: 1,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 30,
    width: 3,
    height: 14,
    rx: 1,
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 12,
    width: 2,
    height: 15,
    rx: 1,
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 30,
    width: 2,
    height: 14,
    rx: 1,
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 12,
    width: 3,
    height: 15,
    rx: 1,
    fill: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 30,
    width: 3,
    height: 14,
    rx: 1,
    fill: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 54.5,
    y: 12,
    width: 3,
    height: 15,
    rx: 1,
    fill: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 54.5,
    y: 30,
    width: 3,
    height: 14,
    rx: 1,
    fill: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 12,
    width: 2,
    height: 15,
    rx: 1,
    fill: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 30,
    width: 2,
    height: 14,
    rx: 1,
    fill: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 12,
    width: 4,
    height: 15,
    rx: 1,
    fill: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 30,
    width: 4,
    height: 14,
    rx: 1,
    fill: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 29,
    width: 59,
    height: 2,
    rx: 1,
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaserScanIcon);
export default __webpack_public_path__ + "static/media/laser-scan-icon.3a8da3c9bede14bde4dd755c45a8cd2f.svg";
export { ForwardRef as ReactComponent };